module.exports = __webpack_public_path__ + "img/telegram-white.a82ca8cc.svg";